import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Spinner } from 'reactstrap';
import productService from '../../services/productService';
import ProductDocumentLines from './ProductDocumentLines';
import './ProductList.css';

export default function ProductDocumentPage() {
  const { articleId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const initial = String(location.state?.product?.id) === articleId ? location.state.product : null;
  const [product, setProduct] = useState(initial);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setError(false);
    if (!initial) {
      setProduct(null);
      productService.findById(articleId, controller.signal).then(result => {
        if (active) setProduct(result);
      }).catch(() => { if (active) setError(true); });
    } else setProduct(initial);
    return () => { active = false; controller.abort(); };
  }, [articleId, initial, retry]);
  const back = () => navigate(location.state?.articlesReturnTo || '/inventory-module/products', {
    state: { productList: location.state?.productList },
  });
  if (error) return <main className="product-lines-page"><Button color="light" onClick={back}>← Retour aux articles</Button>
    <Alert color="danger" className="mt-3">Impossible de charger l'article. <Button color="link" onClick={() => setRetry(value => value + 1)}>Réessayer</Button></Alert></main>;
  if (!product) return <div className="p-5 text-center" role="status"><Spinner size="sm" /> Chargement de l'article…</div>;
  return <ProductDocumentLines key={product.id} product={product} onClose={back} />;
}
